<template>
    <form-row title="Is your property part of an Homeowners Association?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_hoa"
                v-model="has_hoa"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-money
                v-if="has_hoa"
                class="ml-12 mb-6"
                label="HOA Fees"
                :value="mortgage.hoa_fees"
                name="hoa_fees"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_hoa: this.mortgage.has_hoa,
        }
    },

    watch: {
        has_hoa(value) {
            if (! value) {
                this.mortgage.hoa_fees = null;
            }
        },
    },
}
</script>
